<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Condiciones de Pago
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Condiciones de Pago</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6;">
      <div></div>
      <button type="button" mdbBtn color="info" (click)="muestraModalAgrega();showModalAgregar()" size="sm"
        mdbWavesEffect>Agregar</button>
    </div>
    <div class="row filtros-body">
      <div class="col">
        <!-- Material inline 1 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="1" mdbInput />
          <label class="form-check-label" for="materialInline1">Activos</label>
        </div>

        <!-- Material inline 2 -->
        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="2" mdbInput />
          <label class="form-check-label" for="materialInline2">Inactivos</label>
        </div>

        <div class="form-check form-check-inline">
          <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
            [(ngModel)]="busquedaEstado" [value]="3" mdbInput />
          <label class="form-check-label" for="materialInline3">Todos</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div></div>
    <button mdbBtn type="button" color="secondary" (click)="filtraxEstado()" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon>
      Buscar
    </button>
  </div>
</div>



<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Descripcion</th>
            <th scope="col">Dias</th>
            <th scope="col">Recargo</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let condipag of condipagList">
            <td>{{ condipag.descripcion }}</td>
            <td>{{ condipag.cantidad_dias }}</td>
            <td>{{ condipag.recargoporc }}</td>
            <td>
              <div *ngIf="condipag.estado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!condipag.estado">
                <mdb-badge pill="false" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button class="btn-actions-sm" color="info" mdbBtn type="button" size="sm" mdbWavesEffect
                data-toggle="modal" data-target="#basicExample" (click)="showModalModificar(); showForEdit(condipag)"
                mdbTooltip="Ver" placement="right">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button>

              <button *ngIf="!condipag.estado" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                (click)="permitirCambioEstado(condipag)" mdbTooltip="Activar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button *ngIf="condipag.estado" class="btn-actions-sm" color="success" mdbBtn type="button"
                mdbWavesEffect (click)="permitirCambioEstado(condipag)" mdbTooltip="Desactivar" placement="right">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<div mdbModal #centralLarge="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Agregar
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLarge.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formAgregarCondicionPago">
          <div class="container">
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input placeholder="Descripcion" class="form-control" type="text" id="descripcion"
                    formControlName="descripcion" value="" #descripcion maxlength="100" />
                  <label for="descripcion">Descripción</label>
                </div>
                <div *ngIf="
                  frmAgregaDescripcion.invalid &&
                  (frmAgregaDescripcion.dirty ||
                    frmAgregaDescripcion.touched)
                ">
                  <mdb-error *ngIf="frmAgregaDescripcion.errors.required">
                    La descripción es requerida
                  </mdb-error>
                  <mdb-error *ngIf="frmAgregaDescripcion.errors.maxlength">
                    La descripción no puede superar los 100 caracteres
                  </mdb-error>
                  <mdb-error *ngIf="frmAgregaDescripcion.errors.minlength">
                    La descripción debe tener un mínimo de 5 caracteres
                  </mdb-error>
                </div>

                <!--Radio buttons-->

                <!--Radio buttons-->

                <div class="md-form">
                  <div style="width: 100%">
                    <!-- Material inline 1 -->
                    <h6>Ambito de uso:</h6>
                    <br />
                    <mdb-checkbox formControlName="usoCompra">Compra</mdb-checkbox>

                    <!-- Material inline 2 -->
                    <mdb-checkbox formControlName="usoVenta">Venta</mdb-checkbox>
                  </div>

                  <div class="md-form">
                    <mdb-select
                      [options]="optionsCondicionPagoSII"
                      formControlName="condipagsii"
                      [multiple]="false"
                      [filterEnabled]="true"
                      [highlightFirst]="false"
                      placeholder="Seleccionar condición pago SII"
                    ></mdb-select>
                    <label>Condición pago SII</label>
                  </div>

                </div>
              </div>
              <div class="col">
                <div class="md-form">
                  <input placeholder="Dias" class="form-control" type="number" min="0" id="cantidadDias"
                    formControlName="cantidadDias" value="" #cantidadDias (change)="cambiaSII()" />
                  <label for="cantidadDias">Dias (Plazo sin documentar)</label>
                </div>
                <div *ngIf="
                  frmAgregaCantidadDias.invalid &&
                  (frmAgregaCantidadDias.dirty ||
                    frmAgregaCantidadDias.touched)
                ">
                  <mdb-error *ngIf="frmAgregaCantidadDias.errors.required">
                    La cantidad de días es requerida
                  </mdb-error>
                  <mdb-error *ngIf="frmAgregaCantidadDias.errors.min">
                    La cantidad de días no puede ser menor a 1
                  </mdb-error>
                  <mdb-error *ngIf="frmAgregaCantidadDias.errors.max">
                    La cantidad de días no puede superar los 365
                  </mdb-error>
                </div>
                <div class="md-form">
                  <input value="0" type="number" min="0" id="recargoporc" class="form-control"
                    formControlName="recargoPorc" placeholder="Recargo" #recargoporc />
                  <label for="recargoporc">Recargo (Al vender %)</label>
                </div>
                <div *ngIf="
                  frmAgregaRecargoPorc.invalid &&
                  (frmAgregaRecargoPorc.dirty ||
                    frmAgregaRecargoPorc.touched)
                ">
                  <mdb-error *ngIf="frmAgregaRecargoPorc.errors.min">
                    El porcentaje de recargo no puede ser menor a 0%
                  </mdb-error>
                  <mdb-error *ngIf="frmAgregaRecargoPorc.errors.max">
                    El porcentaje de recargo no puede ser mayor a 99%
                  </mdb-error>
                </div>

                <div class="switch info-switch">
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="estado" formControlName="estado" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLarge.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" class="btn btn-secondary waves-light" [disabled]="!formAgregarCondicionPago.valid"
          mdbWavesEffect (click)="insertar(); centralLarge.hide()">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>

<div mdbModal #centralLargex="mdb-modal" class="modal fade" id="basicExamplex" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Modificar Condiciones de Pago
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="centralLargex.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <form [formGroup]="formEditarCondicionPago">
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input value="" type="text" id="codigox" class="form-control" formControlName="codigo" #codigox />
                  <label for="codigox">Código</label>
                </div>

                <div class="md-form">
                  <input type="text" id="descripcionx" formControlName="descripcion" class="form-control" #descripcionx
                    maxlength="100" />
                  <label for="descripionx">Descripción</label>
                </div>
                <div *ngIf="
                  frmEditarDescripcion.invalid &&
                  (frmEditarDescripcion.dirty ||
                    frmEditarDescripcion.touched)
                ">
                  <mdb-error *ngIf="frmEditarDescripcion.errors.required">
                    La descripción es requerida
                  </mdb-error>
                  <mdb-error *ngIf="frmEditarDescripcion.errors.maxlength">
                    La descripción no puede superar los 100 caracteres
                  </mdb-error>
                  <mdb-error *ngIf="frmEditarDescripcion.errors.minlength">
                    La descripción debe tener un mínimo de 5 caracteres
                  </mdb-error>
                </div>

                <div class="md-form">
                  <div style="width: 100%">
                    <!-- Material inline 1 -->
                    <h6>Ambito de uso:</h6>
                    <br />
                    <mdb-checkbox formControlName="usoCompra">Compra</mdb-checkbox>

                    <!-- Material inline 2 -->
                    <mdb-checkbox formControlName="usoVenta">Venta</mdb-checkbox>
                  </div>
                </div>
                <div class="md-form">
                  <mdb-select
                    [options]="optionsCondicionPagoSII"
                    formControlName="condipagsii"
                    [multiple]="false"
                    [filterEnabled]="true"
                    [highlightFirst]="false"
                    placeholder="Seleccionar condición pago SII"
                  ></mdb-select>
                  <label>Condición pago SII</label>
                </div>

                <div class="md-form"></div>
              </div>
              <div class="col">
                <div class="md-form">
                  <input formControlName="cantidadDias" class="form-control" type="text" id="cantidadDiasx"
                    #cantidadDiasx />
                  <label for="cantidadDiasx">Dias</label>
                </div>
                <div class="md-form">
                  <input formControlName="recargoPorc" class="form-control" type="text" id="recargoporcx"
                    #recargoporcx />
                  <label for="recargoporcx">Recargo</label>
                </div>
                <div *ngIf="
                  frmEditarRecargoPorc.invalid &&
                  (frmEditarRecargoPorc.dirty ||
                    frmEditarRecargoPorc.touched)
                ">
                  <mdb-error *ngIf="frmEditarRecargoPorc.errors.min">
                    El porcentaje de recargo no puede ser menor a 0%
                  </mdb-error>
                  <mdb-error *ngIf="frmEditarRecargoPorc.errors.max">
                    El porcentaje de recargo no puede ser menor a 99%
                  </mdb-error>
                </div>
                <div class="switch info-switch">
                  <label>Inactivo<input class="form-check-input" type="checkbox" id="estadox"
                      formControlName="estado" />
                    <span class="lever"></span>Activo</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="centralLargex.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
          (click)="actualizar(); centralLargex.hide()">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>